import { StorageModel } from '../../modules/storage/model';

export const FAVOURITE_CAROUSEL = 'VWO_SHOW_FAVOURITE_CAROUSEL';

export type FeatureFlag = typeof FAVOURITE_CAROUSEL;

export const getFlag = (flag: FeatureFlag) => StorageModel.getItem(flag);

export const setFlag = (flag: FeatureFlag, state: boolean) => StorageModel.setItem(flag, state);

type FeatureFlagEventPayload = {
  flag: FeatureFlag;
  flagState: boolean;
};

export type FeatureFlagEvent = CustomEvent<FeatureFlagEventPayload>;
